<template>
  <div class="tile is-3 is-child is-vertical product-tile">
    <div class="image-title-box">
      <figure class="image">
        <!-- <VueLoadImage> -->
          <img :src=product.image_link />
          <!-- <img slot="preloader" :src=loadingImage /> -->
        <!-- </VueLoadImage> -->
      </figure>
      <!-- <div class="level">
        <div class="level-left">
          <div class="level-item">
            <div v-for="i in Math.floor(Math.random() * 5 + 1)" v-bind:key="i"
              class="swatch-circle" v-bind:style="{'background-color': '' + randomColor() + ''}">
            </div>
          </div>
        </div>
      </div> -->
          <p class="title">{{product.title}}</p>
          <label class="brand" v-html="product.brand"></label>
      <div class="columns">
        <div class="column price-col">
          <p><span class="price"></span></p>
          </div>
        <div class="column gauge-col  is-one-half">
          <div v-if="product.product_recommendations.length > 0" class="scoring-message">      
            <div class="scoring-gauge">
              <VueSvgGauge
                :start-angle="-120"
                :end-angle="120"
                :value=product.product_recommendations[0].score
                :separator-step="25"
                :min="0"
                :max="100"
                :inner-radius="50"
                :gauge-color="[{ offset: 0, color: '#22D061'}, { offset: 100, color: '#22D061'}]"
                easing="Back.In"
              >
                <!-- <div class="inner-text">
                  <span>{{product.product_recommendations[0].message}}</span>
                </div> -->
              </VueSvgGauge>  
            </div>
      </div>
        </div>
          <!-- <div v-if="Math.random() > 0.65" class="star-rating">
            <div class="level">
              <div class="level-left">
                <div class="level-item">
                  <VueStarRating v-bind:increment="0.5"
                      v-bind:max-rating="5"
                      inactive-color="#ccc"
                      active-color="#000"
                      v-bind:star-size="10"
                      v-bind:rating="Math.random() * 5 + 1"
                      v-bind:show-rating="false"
                      v-bind:read-only="true">
                  </VueStarRating>
                </div>
                <div class="level-item">
                  <span class="ratings-count">({{Math.floor(Math.random() * 200)}})</span>
                </div>
              </div>
            </div>
          </div> -->
        </div>
    </div>
  </div>
</template>

<script>
// import VueLoadImage from 'vue-load-image';
import { VueSvgGauge } from 'vue-svg-gauge';
// import VueStarRating from 'vue-star-rating';

export default {
  name: "RetailerProduct",
  components: {
    VueSvgGauge,
    // VueLoadImage,
    // VueStarRating
  },
  props: {
    product: Object,
    style_number: Boolean
  },
  data: function() {
    return {
      loadingImage: require("@/assets/images/Spinner.gif")
    }
  },
  methods: {
    randomColor: function() {
      var randomColorStr = "#000000".replace(/0/g,function(){return (~~(Math.random()*16)).toString(16);});
      return(randomColorStr);
    }
  }
}
</script>

<style scoped lang="scss">
  .title {
    font-size: 0.8em;
    font-weight: bold;
    margin-bottom: 0 !important;
  }
  .brand {
    font-size: .6rem;
    font-weight: 500;
  }
  .price {
    font-size: 0.8em;
    font-weight: bold;
  }
  .scoring-message {
    font-style: italic;
    display: grid;
    align-items: start;
    justify-items: end;
  }
  .scoring-gauge {
    display: block;
    max-height: 35px;
    max-width: 35px;
    display: grid;
    align-items: start;
    justify-items: end;
  }
  .gauge{
    width: 100%;
    height: 100%;
  }
  .inner-text {
    width: 100%;
    height: 100%;
    font-size: 2em;
    margin: 35%;
  }
  .image-title-box {
    margin-bottom: auto;
    width: 70%;
    margin-bottom: 1.5rem;
    @media screen and (min-width: 768px) and (max-width: 1320px) {
      width: 100%;
    }
    figure {
      img{
          max-width: 100%;
      }
      margin-bottom: 1em;
    }
  }
  .product-tile {
    padding: 0.5em;
  }

  .swatch-circle {
    min-height: 1.5rem;
    min-width: 1.5rem;
    border-radius: 50%;
    margin-right: 1em;
  }
  .gauge-col {
    display: grid;
    align-items: start;
    justify-items: end;
    @media screen and (max-width: 768px) {
      justify-items: start;
    }
  }
  .price-col {
    align-content: start;
    display: grid;
    left: 0;
    padding-left: 0.7rem !important;
    padding-top: .5rem !important;
  }

  .ratings-count {
    font-size: 0.75rem;
  }

</style>


